export const FIRST_NAME_MAX_LENGTH = 30;
